const kvadrant_I = [
    {broj: 18, selected: false, veza: false},
    {broj: 1817, selected: false, veza: true},
    {broj: 17, selected: false, veza: false},
    {broj: 1716, selected: false, veza: true},
    {broj: 16, selected: false, veza: false},
    {broj: 1615, selected: false, veza: true},
    {broj: 15, selected: false, veza: false},
    {broj: 1514, selected: false, veza: true},
    {broj: 14, selected: false, veza: false},
    {broj: 1413, selected: false, veza: true},
    {broj: 13, selected: false, veza: false},
    {broj: 1312, selected: false, veza: true},
    {broj: 12, selected: false, veza: false},
    {broj: 1211, selected: false, veza: true},
    {broj: 11, selected: false, veza: false},
    {broj: 1121, selected: false, veza: true},
];

const kvadrant_II = [
    {broj: 21, selected: false, veza: false},
    {broj: 2122, selected: false, veza: true},
    {broj: 22, selected: false, veza: false},
    {broj: 2223, selected: false, veza: true},
    {broj: 23, selected: false, veza: false},
    {broj: 2324, selected: false, veza: true},
    {broj: 24, selected: false, veza: false},
    {broj: 2425, selected: false, veza: true},
    {broj: 25, selected: false, veza: false},
    {broj: 2526, selected: false, veza: true},
    {broj: 26, selected: false, veza: false},
    {broj: 2627, selected: false, veza: true},
    {broj: 27, selected: false, veza: false},
    {broj: 2728, selected: false, veza: true},
    {broj: 28, selected: false, veza: false},
];

const kvadrant_III = [
    {broj: 31, selected: false, veza: false},
    {broj: 3132, selected: false, veza: true},
    {broj: 32, selected: false, veza: false},
    {broj: 3233, selected: false, veza: true},
    {broj: 33, selected: false, veza: false},
    {broj: 3334, selected: false, veza: true},
    {broj: 34, selected: false, veza: false},
    {broj: 3435, selected: false, veza: true},
    {broj: 35, selected: false, veza: false},
    {broj: 3536, selected: false, veza: true},
    {broj: 36, selected: false, veza: false},
    {broj: 3637, selected: false, veza: true},
    {broj: 37, selected: false, veza: false},
    {broj: 3738, selected: false, veza: true},
    {broj: 38, selected: false, veza: false},
];


const kvadrant_IV = [
    {broj: 48, selected: false, veza: false},
    {broj: 4847, selected: false, veza: true},
    {broj: 47, selected: false, veza: false},
    {broj: 4746, selected: false, veza: true},
    {broj: 46, selected: false, veza: false},
    {broj: 4645, selected: false, veza: true},
    {broj: 45, selected: false, veza: false},
    {broj: 4544, selected: false, veza: true},
    {broj: 44, selected: false, veza: false},
    {broj: 4443, selected: false, veza: true},
    {broj: 43, selected: false, veza: false},
    {broj: 4342, selected: false, veza: true},
    {broj: 42, selected: false, veza: false},
    {broj: 4241, selected: false, veza: true},
    {broj: 41, selected: false, veza: false},
    {broj: 4131, selected: false, veza: true},
];

export {kvadrant_I};
export {kvadrant_II};
export {kvadrant_III};
export {kvadrant_IV};



// WEBPACK FOOTER //
// ./app/components/stavkaNaloga/kvadrant.js